module.exports = __webpack_public_path__ + "static/img/target-company.7b2e411.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/target-company.png
// module id = Qqkf
// module chunks = 1